import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetApprovedRegionsQueryResponse, GetApprovedRegionsQueryParams, GetApprovedRegions400, GetApprovedRegions401, GetApprovedRegions403, GetApprovedRegions404, GetApprovedRegions410, GetApprovedRegions422, GetApprovedRegions429, GetApprovedRegions500 } from "../types/GetApprovedRegions";

export const getApprovedRegionsQueryKey = (params: GetApprovedRegionsQueryParams) =>     [{url:`/api/credit-flow-backend/private/v1/regions`},...(params ? [params] : [])] as const;
      export function getApprovedRegionsQueryOptions <TData = GetApprovedRegionsQueryResponse, TError = GetApprovedRegions400 | GetApprovedRegions401 | GetApprovedRegions403 | GetApprovedRegions404 | GetApprovedRegions410 | GetApprovedRegions422 | GetApprovedRegions429 | GetApprovedRegions500>(params: GetApprovedRegionsQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getApprovedRegionsQueryKey(params);

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/credit-flow-backend/private/v1/regions`,
              params,
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @link /api/credit-flow-backend/private/v1/regions
 */

export function useGetApprovedRegions <TData = GetApprovedRegionsQueryResponse, TError = GetApprovedRegions400 | GetApprovedRegions401 | GetApprovedRegions403 | GetApprovedRegions404 | GetApprovedRegions410 | GetApprovedRegions422 | GetApprovedRegions429 | GetApprovedRegions500>(params: GetApprovedRegionsQueryParams, options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getApprovedRegionsQueryKey(params);

  const query = useQuery<TData, TError>({
    ...getApprovedRegionsQueryOptions<TData, TError>(params, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
